import React from 'react'
import { useTranslation } from 'react-i18next'
import WatchSvg from '../../../img/svg/watch'
import { CodeFieldBox, CodeLabel, CodeValue, CopyButton, InfoBox, ProgressFill, ProgressTrack, TimerRow } from './index.styled'
import { TOTAL_SECONDS, formatCode } from './helper'

const CodeView = React.memo(({ code, timeLeft, onCopy }) => {
	const { t } = useTranslation()
	const pct = Math.round((timeLeft / TOTAL_SECONDS) * 100)

	return (
		<>
			<CodeLabel>{t('watch.code.label')}</CodeLabel>
			<CodeFieldBox>
				<CodeValue data-testid="code-value">{formatCode(code)}</CodeValue>
				<CopyButton onClick={onCopy} data-testid="copy-button">
					<WatchSvg icon="copy" />
					{t('watch.code.copy')}
				</CopyButton>
			</CodeFieldBox>
			<InfoBox>
				<WatchSvg icon="info" />
				<span>{t('watch.code.info')}</span>
			</InfoBox>
			<TimerRow>
				<span>{t('watch.code.expiry')}</span>
				<span data-testid="timer-value">{timeLeft}{t('watch.code.secondsSuffix')}</span>
			</TimerRow>
			<ProgressTrack>
				<ProgressFill $pct={pct} data-testid="progress-bar" />
			</ProgressTrack>
		</>
	)
})

CodeView.displayName = 'CodeView'
export default CodeView
